import { observable, action, runInAction, computed, toJS } from 'mobx';
import BasePaginationStore from '@store/Common/BasePaginationStore';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import { server_address } from '@src/env-config';
import {message} from "antd";
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";


class Item {
  constructor(data) {
    this.init(data);
  }

  @action
  init(data) {
    for(let attr in data) {
      this[attr] = data[attr];
    }
  }

  @observable
  id = "";

  /**
   * 代理账号
   */
  @observable
  nick_name = "";

  /**
   *代理昵称
   * @type {string}
   */
  @observable
  pet_name = "";

  /**
   * 上级代理名称
   * @type {string}
   */
  @observable
  proxy_pet_name = "";

  /**
   * 投注返佣
   */
  @observable
  radio = 0;
  //修改时使用,用来处理界面更新问题
  @observable
  tempRadio = 0;
  @computed
  get get_radio(){
    return (Number(toJS(this.radio))).mul(100).toFixed(2)+'%';
  }

  /**
   * 投注收入
   */
  @observable
  order_money = "";

  /**
   * 账户余额
   */
  @observable
  balance = "";

  /**
   * 下级代理数量
   */
  @observable
  proxy_num = 0;

  /**
   * 上级代理id
   */
  @observable
  proxy_id = "";

  /**
   * 所属会员数量
   */
  @observable
  user_num = 0;

  /**
   * 是否允许下级
   * 0允许
   * @type {string}
   */
  @observable
  recommended_status = 0;

  @computed
  get is_recommended_status() {
    return Boolean(Number(toJS(this.recommended_status)))
  }

  /**
   * 是否允许查看总输赢
   * 0不冻结
   * @type {number}
   */
  @observable
  determinedstars = 0;
  @computed
  get is_determinedstars() {
    return Boolean(Number(toJS(this.determinedstars)))
  }

   /**
   * 钱包状态,是否冻结
   * 0不冻结
   * @type {number}
   */
  @observable
  wallet_status = 0;
  @computed
  get is_wallet_status() {
    return Boolean(Number(toJS(this.wallet_status)))
  }
  /**
   * 注册时间
   * @type {string}
   */
  @observable
  register_time = "";

  /**
   * 是否为代理
   * @type {number}
   */
  @observable
  is_proxy = 0;

  /**
   * 允许代充
   * 0允许
   * @type {number}
   */
  @observable
  wallet_type = 0;
  @computed
  get is_wallet_type() {
    return Boolean(Number(toJS(this.wallet_type)))
  }

  /**
   * 代理等级
   */
  @observable
  superior_level = 0;

  /**
   * 头像连接
   * @type {string}
   */
  @observable
  tailor_user = '';
  @computed
  get tailor_user_url(){
    if (this.tailor_user == '')
    {
      return ''
    }
    else
    {
      return `${server_address}${this.tailor_user}`;
    }
  }

  /**
   * 邀请码
   */
  @observable
  other_from = '';

  /**
   * 上次登录ip
   * @type {string}
   */
  @observable
  login_ip = '';

  /**
   * 上线名称
   */
  @observable
  proxy_nick_name;

  /**
   * 推广码
   */
  @observable
  proxy_number;

  /**
   * 下级总充值
   */
  @observable
  user_proxy_pay_money;

  /**
   * 个人总充值
   */
  @observable
  user_pay_money;

  /**
   * 个人总输赢
   */
  @observable
  yinkui;

  /**
   * 彩金
   */
  @observable
  mosaic_gold;
}

class PaginationStore extends BasePaginationStore {

}

/**
 * 页面头部筛选过滤器字段值
 */
class FilterStore {

  //是否初始化过
  is_init;

  search;
  type;

  @action
  setAttr({search,type}) {
    this.resetAttr();

    this.search = search;

    if (type == undefined)
    {
      this.type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_AGENT_ALL);
    }
    else
    {
      this.type = type;
    }

    this.is_init = true;
  }

  getAttr() {
    return {
      search: this.search,
      type: this.type,
    }
  }

  setDefault() {
    this.resetAttr();
    this.type = 2;
    this.search = '';
    this.is_init = true;
  }

  @action
  resetAttr() {
    this.search = undefined;
    this.type = undefined;
    this.is_init = undefined;
  }
}

let filter_store = new FilterStore();

class ItemStore {

  constructor(pagination) {
    this.init(pagination);
  }

  @action
  init(pagination){
    this.pagination_store = pagination;
  }

  @observable
  item_map = new Map();

  @observable
  pagination_store;

  @observable
  new_num = 0;

  @observable
  total = 0;

  @observable
  currentUserId = '';

  /**
   *  item数组列表
   */
  @computed
  get item_array() {
    let res = [];
    this.item_map.forEach((values, key) => {
      res.push(values);
    });
    return res;
  }

  /**
   * 编辑中的 item
   */
  @observable
  editting_item = new Item();

  /**
   * 控制编辑 modal 是否显示
   */
  @observable
  is_edit_modal_show = true;

  /**
   * 打开 modal 显示
   */
  @action
  openEditModal() {
    this.is_edit_modal_show = true;
  }

  /**
   * 关闭 modal 显示
   */
  @action
  closeEditModal() {
    this.editting_item = new Item();
    this.is_edit_modal_show = false;
  }

  reloadDatas(filter) {
    this.item_map.clear();
    this.new_money = 0;
    this.pagination_store.clear();

    if (filter == undefined)
    {
      if (filter_store.is_init == undefined)
      {
        filter_store.setDefault()
      }
    }
    else
    {
      filter_store.setAttr(filter);
    }

    this.searchByFilter();
  }

  /**
   * 根据条件搜索 item
   * @param {*} page_opts
   */
  async searchByFilter(page_opts){
    let page_option = {
      page: this.pagination_store.page_cur,
      page_size: this.pagination_store.page_size,
      ...filter_store.getAttr(),
      ...page_opts
    }
    let res = await this._getItemArray(page_option);
    return res;
  }

  /**
   * 获取 item列表
   */
  async _getItemArray(page_option = {}) {
    let url = fetchUrl.agent.index;
    let res = await service.fetchData({
      path: url,
      params: {
        id:this.currentUserId,
        ...page_option
      }
    });
    service.responseHandle({
      res: res,
      success_handle: (res) => {
        runInAction(() => {
          // console.log(res);
          this.item_map.clear();
          res.data.data.forEach((item, index) => {
            this.item_map.set(item.id, new Item(item));
          });
          this.pagination_store.setAttr(res.data.page);
          this.new_num = res.data.new_num;
          this.total = res.data.total;
        })
      },
      fail_handle: (res) => {
        message.error(res.error.error_data,3);
        this.pagination_store.clear();
        filter_store.resetAttr();
        this.item_map.clear();
      }
    })
    return res;
  }

  /**
   * 获取单个 item信息
   * @param {string} item_id
   */
  async getItemData(item_id) {
    let url = fetchUrl.agent.get_item;
    let res = await service.fetchData({
      path: url,
      params: {
        id: item_id
      }
    });
    service.responseHandle({
      res: res,
      success_handle: (res) => {
        runInAction(() => {
          this.editting_item = new Item(res.data);
        })
      }
    });
    return res.data;
  }


  /**
   * 编辑用户权限
   * @param {Item} item item
   */
  async proxyEdit(item){
    let url = fetchUrl.agent.proxyEdit;
    let res = await service.fetchData({
      path: url,
      params: {
        id: item.id,
        wallet_type:item.wallet_type,
        wallet_status:item.wallet_status,
        recommended_status:item.recommended_status,
        radio:item.radio
      }
    });
    return res;
  }

}

let pagination_store = new PaginationStore();
let item_store = new ItemStore(pagination_store);

export {
  pagination_store,
  filter_store
}
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Agent/AgentStore.js